import ApiService from "@/services/api.service";

class RegistrationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const buildRegistrationError = (error, fallbackMessage) => {
  const status = error && error.response ? error.response.status : null;
  const data = error && error.response ? error.response.data : null;
  const message =
    (data && (data.detail || data.message || data.error)) ||
    error.message ||
    fallbackMessage;
  return new RegistrationError(status, message);
};

const RegistrationService = {
  getByToken: async function(token) {
    try {
      const response = await ApiService.get(`/mes-inscriptions/${token}`);
      return response;
    } catch (error) {
      throw buildRegistrationError(error, "Impossible de charger l'inscription.");
    }
  },

  updateByToken: async function(token, payload) {
    try {
      const response = await ApiService.put(`/mes-inscriptions/${token}`, payload);
      return response;
    } catch (error) {
      throw buildRegistrationError(error, "Impossible de mettre à jour l'inscription.");
    }
  },

  removeByToken: async function(token) {
    try {
      const response = await ApiService.delete(`/mes-inscriptions/${token}`);
      return response;
    } catch (error) {
      throw buildRegistrationError(error, "Impossible de supprimer l'inscription.");
    }
  }
};

export default RegistrationService;

export { RegistrationService, RegistrationError };
